import { AppThunkApi, PdpState } from 'os/pdp/shared/redux/src/store';
import { Dictionary } from '@reduxjs/toolkit';
import { createAuthorizationHeader } from '@ff-os/shared-utils/private-urls';
import { urls } from '@ff-os/shared-utils/urls';
import { ExternalUploader } from '../../slices/externalUploadersSlice';
import { withAuthorization } from '../authorization/withAuthorization';
import { ExternalUploadAsset } from './externalUploaderPoller';

export const pollExternalUploads = async (updatedOn: number, thunkApi: AppThunkApi<any>) => {

    const response = await withAuthorization(async (state: PdpState) => {
        return fetch(urls.pollExternalUploads, formatRequest(state, updatedOn));
    }, thunkApi);

    if (response.ok) {
        const state = thunkApi.getState();
        const result = await response.json() as PollResponse;
        return {
            updatedOn: result.updatedOn,
            assets: withExternalUploaderMeta(result.assets, state.externalUploaders.entities)
        };
    } else {
        throw new Error(`Error while creating external uploader`);
    }
};

const formatRequest = (state: PdpState, updatedOn: any) => ({
    method: 'POST',
    mode: 'cors' as RequestMode,
    headers: {
        ...createAuthorizationHeader(state.auth.jwt!),
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        updatedOn: updatedOn
    })
});

type PollResponse = {
    updatedOn: number;
    assets: Asset[];
};

type Asset = {
    assetId: string;
    url: string;
    fileName: string;
    meta: any;
    externalUploaderId: string;
};

const withExternalUploaderMeta = (
    assets: Asset[],
    entities: Dictionary<ExternalUploader<any>>
): ExternalUploadAsset<any>[] => {

    const assetsWithPayload = [];

    for (const asset of assets) {
        const externalUploader = entities[asset.externalUploaderId];
        if (externalUploader !== undefined) {
            assetsWithPayload.push({
                ...asset,
                externalUploaderPayload: externalUploader.settings.payload
            });
        }
    }

    return assetsWithPayload;
};